import { render, staticRenderFns } from "./RoundCheckIcon.vue?vue&type=template&id=525d4ef1&"
import script from "./RoundCheckIcon.vue?vue&type=script&lang=js&"
export * from "./RoundCheckIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports